import useIsMobile from "@/hooks/useIsMobile";
import useChat from "./useChat";
import ChatDesktop from "./desktop";
import ChatMobile from "./mobile";

const ChatPage = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useChat();

  return isMobile ? <ChatMobile viewModel={viewModel} /> : <ChatDesktop viewModel={viewModel} />;
};

export default ChatPage;
